export const schedule = (job, periodInMilliseconds) =>
  setInterval(job, periodInMilliseconds);
